import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
import { css, memoizeStyle } from "../../../lib/theming/Emotion";
import { getMenuItemPaddings } from "../../../components/MenuItem/MenuItem.styles";
export var styles = memoizeStyle({
  root: function root(t) {
    var _getMenuItemPaddings = getMenuItemPaddings({
        menuItemPaddingX: t.menuMessagePaddingX,
        menuItemPaddingY: t.menuMessagePaddingY
      }),
      paddingX = _getMenuItemPaddings.paddingX,
      paddingY = _getMenuItemPaddings.paddingY;
    return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n      margin: 0;\n      display: ", ";\n      padding: ", " ", " ", " ", ";\n      color: ", ";\n      background: ", ";\n    "])), t.menuMessageDisplay, t.menuMessagePaddingY, paddingX, paddingY, t.menuMessagePaddingX, t.menuMessageTextColor, t.menuMessageBg);
  },
  rootMobile: function rootMobile(t) {
    return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n      font-size: ", ";\n      line-height: ", ";\n      padding: ", ";\n    "])), t.menuMessageFontSizeMobile, t.menuMessageLineHeightMobile, t.menuMessagePaddingMobile);
  },
  rootSmall: function rootSmall(t) {
    return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n      font-size: ", ";\n      line-height: ", ";\n    "])), t.menuMessageFontSizeSmall, t.menuMessageLineHeightSmall);
  },
  rootMedium: function rootMedium(t) {
    return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n      font-size: ", ";\n      line-height: ", ";\n    "])), t.menuMessageFontSizeMedium, t.menuMessageLineHeightMedium);
  },
  rootLarge: function rootLarge(t) {
    return css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n      font-size: ", ";\n      line-height: ", ";\n    "])), t.menuMessageFontSizeLarge, t.menuMessageLineHeightLarge);
  }
});